// Single source of truth for the user's "tier" badge.
// We don't have a subscription model — only one-time credit packs — so the
// tier is derived from `profiles.credits_purchased_total` (lifetime credits
// the user has paid for). Thresholds line up with the credit-pack ladder in
// CREDIT_PACKS so each rung corresponds to a real purchase.
//
// free    : never purchased
// starter : bought any pack (5+ credits)
// pro     : bought a "hot"/"value" pack (22+ credits) ever
// elite   : bought the "pro" or "mega" pack (80+ credits) ever
export type UserTier = "free" | "starter" | "pro" | "elite";

export function getUserTier(creditsPurchasedTotal: number | null | undefined): UserTier {
  const n = Number(creditsPurchasedTotal ?? 0);
  if (n >= 80) return "elite";
  if (n >= 22) return "pro";
  if (n > 0)   return "starter";
  return "free";
}

export const TIER_META: Record<UserTier, { label: string; emoji: string; className: string }> = {
  free: {
    label: "Free",
    emoji: "✨",
    className: "bg-muted/60 text-muted-foreground border-white/10",
  },
  starter: {
    label: "Starter",
    emoji: "🌟",
    className: "bg-primary/15 text-primary border-primary/30",
  },
  pro: {
    label: "Pro",
    emoji: "🔥",
    className:
      "bg-gradient-to-r from-primary/90 to-accent/90 text-primary-foreground border-transparent shadow-[0_0_18px_-4px_hsl(var(--primary))]",
  },
  elite: {
    label: "Elite",
    emoji: "💎",
    className:
      "bg-gradient-to-r from-accent to-primary text-accent-foreground border-transparent shadow-[0_0_24px_-4px_hsl(var(--accent))]",
  },
};
